import { useEffect, useRef, useState } from 'react';
import styles from '@components/VideoLaptopComponent/VideoLaptopComponent.styles';
import VideoPlayer from '@components/Video/VideoPlayer';
import { IVideoWithThumbnailPim } from '@features/cms/typescript';
import { BASE_PATH } from '@config/index';
import { TFullResponsiveVideo, TImage } from '@components/typescript';
import ResponsiveImage from '@components/ResponsiveImage/ResponsiveImage';
type PropsType = {
  video?: IVideoWithThumbnailPim;
  image?: TImage;
  playVideo: boolean;
  title: string;
};
const VideoLaptopComponent = ({
  video = undefined,
  playVideo,
  image = undefined,
  title
}: PropsType) => {
  const [laptopHeight, setLaptopHeight] = useState(0);
  const laptopRef = useRef<HTMLDivElement | null>(null);
  const getPoster = () => {
    if (!video?.thumbnail) return '';
    if (!video?.thumbnail.desktop) return '';
    return typeof video.thumbnail.desktop === 'string' ? video.thumbnail.desktop : video.thumbnail.desktop.path;
  };
  const getLaptopHeight = () => setLaptopHeight(laptopRef.current?.clientWidth ? laptopRef.current?.clientWidth * 0.5734494 : 0);
  useEffect(() => {
    getLaptopHeight();
    window.addEventListener('resize', getLaptopHeight);
    return () => {
      window.removeEventListener('resize', getLaptopHeight);
    };
  }, []);
  return <div sx={styles.laptopContainer(laptopHeight)} ref={laptopRef}>
      <ResponsiveImage image={`${BASE_PATH}/img/laptop.png`} alt="" objectFit="contain" />
      <div sx={styles.videoContainer}>
        {video?.video ? <VideoPlayer video={video.video as TFullResponsiveVideo} loop poster={getPoster()} playVideo={playVideo} alt={title} /> : image?.desktop && <ResponsiveImage image={typeof image.desktop === 'string' ? image.desktop : image.desktop.path} alt={typeof image.desktop !== 'string' ? image.desktop.metadata?.alt || title : title} />}
      </div>
    </div>;
};
export default VideoLaptopComponent;